module.exports = __webpack_public_path__ + "images/emoji/balloon.b9600c9eddd978ea5a8c.png";